define('jquery.amd',['lib/jquery.ui'], function (jQuery){ return jQuery; });

